import { UliActivityType } from '../../../../../../common/constants/uli';
import { DriverIdType, TruckLoadingType } from '../../../../administration';
import { TruckSize } from '../../../../../../common';

export interface UliPreviewInformationTransportOrder {
  numberOfHU: number;
  toNumber: string;
}

export class UliPreviewInformationCriteria {
  compartmentId: number;
  uliType: UliActivityType;
  uli: string;
}

export class UliPreviewInformationSmsCriteria extends UliPreviewInformationCriteria {
  phoneNumber: string;
  hubId: number;
  loadNumber: string;
  language: string;
  webUliInfoSmsConsentView?: UliPdfPreviewSmsConsentModel;
}

export class UliPdfPreviewSmsConsentModel {
  consentGiven: boolean;
  signaturePicInBase64: string;
  phoneCountry: string;
  phoneNumber: string;
}

export class UliPdfPreviewContactDataModel {
  carrierExtId: string;
  carrierName: string;
  carrierPhone: string;
  carrierEmail: string;
  rbTransportPlannerEmail: string;
  rbTransportPlannerPhone: string;
}

export class UliPdfPreviewDockAllocationModel {
  user: string;
  dock: string;
  compartment: string;
  bookingTime: string;
  slotAllocationTimeFrom: string;
  slotAllocationTimeTill: string;
  hubName: string;
  ruleName: string;
}

export class UliPdfPreviewDriverModel {
  firstName: string;
  lastName: string;
  permitType: DriverIdType;
  permitNumber: string;
  phoneNumber: string;
  loanerPhoneId: number;
  frequentDriverId: number;
}

export class UliPdfPreviewTruckModel {
  swapBody: boolean;
  dangerousGoods: boolean;
  customsGoods: boolean;
  truckSize: TruckSize;
  loadingTypes: TruckLoadingType[];
  truckPlateId: string;
  truckPlateIdCountryOfOrigin: string;
  trailerPlateId: string;
  trailerPlateIdCountryOfOrigin: string;
}

export class UliPdfPreviewUliModel {
  type: UliActivityType;
  consignmentItems: number;
  customGoods: boolean;
  dangerousGoods: boolean;
  deliveryAddress: string;
  deliveryAddressName: string;
  documentNumbers: string[];
  incompleteUli: boolean;
  loadNumber: string;
  loadingMeters: number;
  pickUpAddress: string;
  pickUpAddressName: string;
  qrCode: string;
  scheduledDateTime: string;
  totalWeight: number;
  transportOrderViews: UliPreviewInformationTransportOrder[];
  uli: string;
}

export class UliPdfPreviewModel {
  contactDataView: UliPdfPreviewContactDataModel;
  dockAllocationView: UliPdfPreviewDockAllocationModel;
  driverInformationView: UliPdfPreviewDriverModel;
  qrCode: string;
  slotId: number;
  truckInformationView: UliPdfPreviewTruckModel;
  uliViews: UliPdfPreviewUliModel[];
}

export class UliInformationPreviewStateModel {
  data?: UliPdfPreviewModel;
  loaded: boolean;
}
